import React from "react";
import "./style.css";
import { MdOutlineLocationOff } from "react-icons/md";
import { IoRefreshOutline } from "react-icons/io5";

const Geolocalizacao = ({ erroGeolocalizacao }) => {
    return (
        <div className="geolocalizacao-container">
            <MdOutlineLocationOff size={80} color="dodgerblue"/>

            <span className="geolocalizacao-titulo">
                {erroGeolocalizacao}                
            </span>

            <button className="geolocalizacao-refresh" onClick={() => window.location.reload(false)}>
                {/* <IoRefreshOutline size={22}/> */}
                <span>Atualizar</span>
            </button>
        </div>
    );
};

export default Geolocalizacao;